import { render, staticRenderFns } from "./ChooseIcon.vue?vue&type=template&id=17164f30&scoped=true&lang=pug"
import script from "./ChooseIcon.vue?vue&type=script&lang=js"
export * from "./ChooseIcon.vue?vue&type=script&lang=js"
import style0 from "./ChooseIcon.vue?vue&type=style&index=0&id=17164f30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17164f30",
  null
  
)

export default component.exports